import React from 'react';
import {connect} from 'react-redux';
import {ModeTabs as Puzzle} from 'components/organisms/mode-tabs/components/index';

class ModeTabs extends Puzzle {
    render() {
        const {filters, players} = this.props;

        return (
            <ul className="table-tab">
                {this.getOverallTab({
                    isActive: filters.isModeOverall(),
                    playersQuantity: players.data.playersCount,
                })}
                {this.getFavoriteTab({
                    isActive: filters.isModeFavorite(),
                    playersQuantity: players.data.playersCount - players.data.totalExcludedQnt,
                })}
                {this.getExcludedTab({
                    isActive: filters.isModeExcluded(),
                    playersQuantity: players.data.totalExcludedQnt,
                })}
                {this.getLockTab({
                    isActive: filters.isModeLocked(),
                    playersQuantity: players.data.lockedCount,
                })}
            </ul>
        );
    }
}

function mapStatesToProps(state) {
    const {players, filters} = state.playersData;
    return {
        players,
        filters,
    };
}

let Tabs = connect(mapStatesToProps)(ModeTabs);

export {Tabs};
